import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { PvtSellRequest } from "../../../apis/privatesell/enitites";

interface Props {
	transaction: PvtSellRequest;
	onDismiss: () => void;
}

class AcceptRequestSuccess extends Component<Props> {
	render() {
		const { transaction } = this.props;
		let message = Strings.req_sell_accepted;
		return <Popup
			id={ "AcceptRequestSuccessPopup" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.confirmation }
			onDismiss={ this.dismissModel }>
			<div className="d-flex flex-column">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ message }</p>
				<div className="refn-box">
					{ Strings.booking_ref_number }: <span>{ transaction.bookingRequestInfo!.referenceNumber! }</span>
				</div>
				<div className="refn-box">
					{ Strings.procedure_number }: <span>{ getProcedureNumber( transaction.bookingRequestInfo ) }</span>
				</div>
				<div className="col-12 text-center mb-3">
					<button type="button" className="btn btn_1" onClick={ this.dismissModel }>{ Strings.home }</button>
				</div>
			</div>
		</Popup>;
	}

	private dismissModel = () => {
		this.props.onDismiss();
	};
}

export function getProcedureNumber( request: any ): string | undefined {
	if ( request && request.procedureNumber && request.procedureYear ) {
		if ( request.procedureNumber !== 0 ) {
			return "" + request.procedureNumber + "/" + request.procedureYear + "";
		}
	}
	return undefined;
}

export default AcceptRequestSuccess;
